import classNames from "classnames";
import React from "react";
import styles from "./DeleteCrossIcon.css";

interface Props {
  onClick(): void;
  className?: string;
}
export const DeleteCrossIcon = ({ onClick, className }: Props) => {
  return (
    <i
      className={classNames("icon-close-cross", styles["delete-icon"], className)}
      onClick={onClick}
    />
  );
};
